import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalActividadesTrabajadorPage } from './modal-actividades-trabajador.page';

const routes: Routes = [
  {
    path: '',
    component: ModalActividadesTrabajadorPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalActividadesTrabajadorPageRoutingModule {}
